import React, { Component } from 'react';
import './FileNameBox.css';
import { projectNameValidator } from '../../config/validation';
import { getTranslation } from '../../assets/creator/translations';

const FileIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ objectFit: 'contain' }}>
        <path fill="#2E2E2E" fillRule="evenodd" d="M14.334 1.546c.936 0 1.851.374 2.544 1.032l.156.157 2.842 3.03a4.068 4.068 0 0 1 1.088 2.566l.007.244v9.88c0 2.136-1.597 3.886-3.6 3.993l-.196.005H6.825c-2.028 0-3.69-1.683-3.791-3.793l-.005-.206V5.544c0-2.135 1.598-3.885 3.601-3.992l.195-.006h7.509zm-.53 1.5H6.825c-1.213 0-2.21 1.03-2.29 2.328l-.006.17v12.91c0 1.321.946 2.406 2.139 2.494l.157.005h10.35c1.214 0 2.21-1.029 2.29-2.328l.006-.17V9.152h-3.904c-.923 0-1.683-.741-1.757-1.68l-.006-.15V3.045zm-.304 9.7a.75.75 0 1 1 0 1.5H6.753a.75.75 0 0 1 0-1.5H13.5zm-2.224-3.769a.75.75 0 1 1 0 1.5H6.754a.75.75 0 1 1 0-1.5h4.522zm4.028-5.688v4.034c0 .152.088.286.203.32l.06.01h3.737a2.605 2.605 0 0 0-.391-.71l-.131-.152-2.841-3.03a2.24 2.24 0 0 0-.467-.376l-.17-.095z" />
    </svg>
)

class FileNameBox extends Component {
    constructor(props) {
        super(props);
        this.state = { isEditing: false };
    }

    startEditing = () => { this.setState({ isEditing: true }) }
    stopEditing = (newValue) => {
        this.setState({ isEditing: false });
        if (typeof newValue === 'string' || newValue instanceof String) {
            this.props.onChange(newValue);
        }
    }

    printValue= () => {
        if(!this.props.value) {
            return "";
        }
        return this.props.value.replace(/ /g,"\u00A0")
    }

    render = () => {
        if (!this.state.isEditing) {
            return (
                <button className="file-name-input file-name-input--passive" onClick={this.startEditing}>
                    <FileIcon className="file-name-input__icon" />
                    <span className="file-name-input__current-value">{this.printValue()}</span>
                    <span className="toggle-change__text">{getTranslation("Change")}</span>
                </button>
            );
        } else {
            return <FileNameBox.LocalStateInput value={this.props.value} stopEditing={this.stopEditing} />;
        }
    }

    
    //inner class since it's not meant to be used outside of this component
    static LocalStateInput = class LocalStateInput extends Component {
        constructor(props) {
            super(props);
            this.state = { value: props.value, isValid: true };
        }
        onInputChange = (e) => {
            const inputNewValue = e.target.value;
            const text = this.validateInput(inputNewValue);

            if (projectNameValidator.test(text)) {
                this.setState({ isValid: true })
            }
            else {
                this.setState({ isValid: false })
            }
            this.setState({ value: text });
        }
    
        onInputKeyPress = (e) => {
            if (e.key === 'Enter') {
                this.stopEditing(true);
            }
            if (e.key === 'Escape') {
                this.stopEditing(false);
            }
        }
        stopEditing = (shouldSave) => {
            if (!shouldSave || !this.state.isValid) {
                this.props.stopEditing();
            } else {
                this.props.stopEditing(this.state.value);
            }
        }
    
        selectAll = (e) => {
            e.target.select();
        }
        validateInput = (inputText) => {
            let text = inputText;
            let len = text.length;
            while(text[0] === ' ') {
                text = text.replace(text[0], '');
                len -= 1;
            }
            return text;
        }
        setButtonStyle = (isValid) => {
            if (!isValid) {
                return { border: 'solid 1px red' };
            } else {
                return null;
            }
        }
        render = () => (
            <button
                className="file-name-input file-name-input--active"
                onBlur={() => this.stopEditing(true)}
                style={this.setButtonStyle(this.state.isValid)}
            >
                
                <input
                    className="file-name-input__input"
                    type="text"
                    maxLength="25"
                    size="20"
                    onFocus={this.selectAll}
                    autoFocus={true}
                    value={this.state.value}
                    onChange={this.onInputChange}
                    onKeyDown={this.onInputKeyPress} 
					
                />
            </button>
        )
        
    }
}

export default FileNameBox
